import { createSlice } from "@reduxjs/toolkit";
import { deleteDB } from "../tools/indexdb";

const storeSlice = createSlice({
  name: "store",
  initialState: {
    store: {},
    page: null,
  },

  reducers: {
    setStore: (state, action) => {
      state.store = action.payload;
    },
    dropStore: (state) => {
      state.store = {};
      deleteDB();
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
});

export default storeSlice.reducer;
export const { setStore, dropStore, setPage } = storeSlice.actions;
